import { Directive, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppSidebarService } from './app-sidebar.service';

@Directive({
  selector: '[appNavDropdown]',
})
export class NavDropdownDirective implements OnInit, OnDestroy {
  sidebarOpen = true;
  private sidebarStatusSubscription: Subscription;

  constructor(
    private el: ElementRef,
    private sidebarService: AppSidebarService,
  ) {}

  toggle() {
    this.el.nativeElement.classList.toggle('open');
  }

  ngOnInit() {
    this.sidebarStatusSubscription = this.sidebarService.sidebarStatus$.subscribe(status => {
      this.sidebarOpen = status;
      if (!this.sidebarOpen) {
        this.el.nativeElement.classList.remove('open');
      }
    });
  }

  ngOnDestroy() {
    this.sidebarStatusSubscription.unsubscribe();
  }
}

/**
 * Allows the dropdown to be toggled via click.
 */
@Directive({
  selector: '[appNavDropdownToggle]',
})
export class NavDropdownToggleDirective implements OnInit, OnDestroy {
  sidebarOpen = true;
  private sidebarStatusSubscription: Subscription;

  constructor(
    private dropdown: NavDropdownDirective,
    private sidebarService: AppSidebarService,
  ) {}

  @HostListener('click', ['$event'])
  toggleOpen($event: any) {
    $event.preventDefault();
    if (!this.sidebarOpen) {
      this.sidebarService.setSidebarOpen(true);
    }
    this.dropdown.toggle();
  }

  ngOnInit() {
    this.sidebarStatusSubscription = this.sidebarService.sidebarStatus$.subscribe(status => {
      this.sidebarOpen = status;
    });
  }

  ngOnDestroy() {
    this.sidebarStatusSubscription.unsubscribe();
  }
}
